import { render, staticRenderFns } from "./elementaryInnovation.vue?vue&type=template&id=3a714c74&"
import script from "./elementaryInnovation.vue?vue&type=script&lang=js&"
export * from "./elementaryInnovation.vue?vue&type=script&lang=js&"
import style0 from "./elementaryInnovation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports